import React from 'react';
import { Icon } from '../../../ui-kit';

export default (() =>
<Icon name="shootstagrad" size={40} color="black" spin />);